import React from 'react'
import Spacer from '../../../components/Spacer';
import Banner from '../../../components/Banner';
import BannerInfo from './BannerInfo';


function Organitation() {
  return (
    <>
    <Banner titleSection={'ORGANIZACIÓN'} linkName={'Inicio'} nameSection={'Organización'} />
    <Spacer/>
    <BannerInfo/>
    <Spacer/>
    </>
  )
}

export default Organitation